'use client';

import type { RefObject } from 'react';
import { toast } from 'sonner';

type FocusableElement = HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement;

/**
 * Показывает ошибку всплывающим уведомлением (toast) и переносит фокус в указанное поле.
 * Использовать при валидации форм и ошибках API, чтобы пользователь сразу видел сообщение
 * и курсор оказывался в поле, которое нужно исправить.
 */
export function showFormError(
  message: string,
  focusRef?: RefObject<FocusableElement | null>
): void {
  toast.error(message);
  if (focusRef?.current) {
    const el = focusRef.current;
    setTimeout(() => {
      el.focus();
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 150);
  }
}
